/** Base64 -> ArrayBuffer */
export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}
/** ArrayBuffer -> Base64 */
export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = ''
  const bytes = new Uint8Array(buffer)
  const len = bytes.byteLength
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}
/** Blob -> ArrayBuffer */
export function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  return blob.arrayBuffer()
}
/** ArrayBuffer -> Blob */
export function arrayBufferToBlob(
  buffer: ArrayBuffer,
  type = 'application/octet-stream'
): Blob {
  return new Blob([buffer], { type })
}
/** Blob -> Base64 */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result
      if (typeof result === 'string') {
        // 去掉前缀 data:xxx;base64,
        resolve(result.split(',')[1])
      } else {
        reject(new Error('Failed to convert Blob to Base64'))
      }
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

const INVALID_FILE_NAME_CHARS_REG = /[\\/:*?"<>|]/g

/**
 * @description 清理文件名中的无效字符
 * @param fileName 名称
 * @param rep 替换字符，默认空字符串
 * @returns 清理后的文件名
 */
export function sanitizeFileName(fileName: string, rep = ''): string {
  return fileName.replace(INVALID_FILE_NAME_CHARS_REG, rep)
}
